// extracted by mini-css-extract-plugin
export default {"container":"tabs__container-q6odr","tabs":"tabs__tabs-oaUN5"};